import { render } from "./WaitingRoom.vue?vue&type=template&id=a3578462&scoped=true"
import script from "./WaitingRoom.vue?vue&type=script&lang=js"
export * from "./WaitingRoom.vue?vue&type=script&lang=js"

import "./WaitingRoom.vue?vue&type=style&index=0&id=a3578462&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3578462"]])

export default __exports__